import React, { Component } from 'react'
import ResultFlightDetails from '../../Components/ResultFlightDetails/ResultFlightDetails'

export class FlightDetails extends Component {
  render() {
    return (
      <div>
        <ResultFlightDetails/>
      </div>
    )
  }
}

export default FlightDetails
